export default __webpack_public_path__ + "static/ly-c3d828f38e52d9bf569e60a49bad84e0.jpeg";